module.exports = __webpack_public_path__ + "public/Icons/logout.svg?cc891336";